import React from 'react';

import Content from '@components/Dashboard/AdminPanel/DeleteCredential';

const DeleteCredential: React.FC = () => {
  return <Content />;
};

export default DeleteCredential;
